import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, FlexboxGrid, Message } from 'rsuite'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import InputForm from '../../../components/forms/input/InputForm'
import { locationZipcode } from '../../../components/location/Location'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import InputTagGroupForm from '../../../components/forms/input/InputTagGroupForm'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import InputCheckboxForm from '../../../components/forms/input/InputCheckboxForm'
import InputCheckboxSingleForm from '../../../components/forms/input/InputCheckboxSingleForm'
import InputRadioForm from '../../../components/forms/input/InputRadioForm'
import EditFormDescriptionWidget from './EditFormDescriptionWidget'
import { cloneDeep } from 'lodash-es'
import CustomAlertMessage from '../../CustomAlertMessage'

export default function SettingEditFormWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  setLoading = () => {},
  onAdd = () => {},
  onRemove = () => {},
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [location, setLocation] = useState([])
  const [objects, setObjects] = useState([])
  const [newObjects, setNewObjects] = useState([])

  useEffect(() => {
    var location = _schema?.objects.find((e) => e.type == 'lOCATION_CASCADER')
    if (location) {
      handleLocation()
    }

    if (_schema?.objects) {
      let uniqueViewGoups = _schema.objects.reduce((acc, obj) => {
        if (!acc.includes(obj['viewGoup'])) {
          acc.push(obj['viewGoup'])
        }
        return acc
      }, [])

      let datas = []

      uniqueViewGoups?.forEach((e) => {
        datas.push(_schema.objects.filter((item) => item.viewGoup == e))
      })

      setObjects(datas)
    }

    setSchema(_schema)
  }, [_schema])

  const handleLocation = async () => {
    setLoading(true)
    let locationJson = await locationZipcode()
    setLocation(locationJson || [])
    setLoading(false)
  }

  const renderInput = (inputForms) => {
    let result = inputForms?.map((e) => {
      return (
        <FlexboxGrid>
          {e.map((item) => {
            let inputObj
            switch (item.type) {
              case 'INPUT':
                inputObj = (
                  <InputForm
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    showLimit={item.showLimitLength}
                  />
                )
                break
              case 'INPUT_NUMBER':
                inputObj = (
                  <InputForm
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    isInputNumber={true}
                    showLimit={item.showLimitLength}
                  />
                )
                break
              case 'INPUT_AREA':
                inputObj = (
                  <InputForm
                    schema={item}
                    rows={4}
                    componentClass="textarea"
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                )
                break
              case 'EDITOR':
                inputObj = (
                  <CKEditorFrom
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                )
                break
              case 'RADIO':
                inputObj = (
                  <InputRadioForm
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    //disabled={disabled || schema.disabled}
                  />
                )
                break
              case 'CHECKBOX':
                inputObj = (
                  <InputCheckboxSingleForm
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    //disabled={disabled || schema.disabled}
                  />
                )
                break
              case 'CHECKBOX_GROUP':
                inputObj = (
                  <InputCheckboxForm
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    //disabled={disabled || schema.disabled}
                  />
                )
                break
              case 'TAG_GROUP':
                inputObj = (
                  <InputTagGroupForm
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    showLimit={item.showLimitLength}
                  />
                )
                break
              case 'DOPDOWN':
                inputObj = (
                  <InputSelectForm
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                )
                break
              case 'LABEL':
                inputObj = (
                  <div style={{ marginTop: 10 }}>
                    <strong>{item.label}</strong>
                  </div>
                )
                break
              case 'MSG':
                inputObj = (
                  <Message showIcon type={item.value || 'success'} description={item.valueDef} />
                )
                break
              default:
                break
            }

            return (
              <FlexboxGrid.Item
                componentClass={Col}
                colspan={24}
                xs={24}
                sm={24}
                md={item.sizeMdLg || 24}
                lg={item.sizeMdLg || 24}
              >
                {inputObj}
                {item.enableDel && (
                  <CancelButton
                    style={{ marginBottom: 10, marginTop: 10 }}
                    icon="trash-o"
                    children="ลบ"
                    onClick={() => {
                      onRemove(item)
                    }}
                  />
                )}
              </FlexboxGrid.Item>
            )
          })}
        </FlexboxGrid>
      )
    })

    return result
  }

  return (
    <Panel>
      <Row>
        {schema.description && (
          <Col style={{ marginBottom: 15 }}>
            <CustomAlertMessage contents={schema.description} />
          </Col>
        )}

        {schema.descriptionSetting && (
          <EditFormDescriptionWidget
            schema={schema.descriptionSetting}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        )}

        {schema.detail && renderInput([[schema.detail]])}

        {renderInput(objects)}

        {schema.enableAdd && (
          <SaveButton
            style={{ marginBottom: 20, marginTop: 20 }}
            icon="plus"
            children="เพิ่ม"
            onClick={onAdd}
          />
        )}

        {schema.note && renderInput([[schema.note]])}
      </Row>
    </Panel>
  )
}
